import { createRef, Component } from 'react';
import igv from '../../node_modules/igv/dist/igv.esm.js';

var igvStyle = {
  paddingTop: '10px',
  paddingBottom: '10px',
  margin: '8px',
  border: '1px solid lightgray',
  maxHeight: "500px",
  overflowY: "auto"
}

class IgvTrackVewer extends Component {

  constructor(props) {
    var { assembly, header, coordinates, reference_track, additional_track, curation_page, vcf} = props;

    super(props)
    this.assembly = assembly;
    this.header = header;
    this.coordinates = coordinates;

    this.curation_page = false;
    this.vcf = vcf;
    if(curation_page !== null)
      this.curation_page = curation_page;
    this.tracks = reference_track;
    if(this.curation_page === true) {
      if(this.vcf !== null && this.vcf !== "") {
        this.tracks.push(
          {
            type: "variant",
            format: "vcf",
            url: this.vcf,
            indexed: false,
            name: "Variants",
            displayMode: "expanded",
            visibilityWindow: 1000
          }
        )
      }
    }
    if(additional_track !== null) {
      for(var i =0; i < additional_track.length; i+=1) {
        this.tracks.push(additional_track[i])
      }
    }
    // Declare reference object for the dom node that will contain the igv.js component
    this.container = createRef(null);
  }

  componentDidMount() {
    var coord = String(this.coordinates);
    var splitted = coord.split(":");
    var chr = splitted[0];
    var coords = splitted[1].split("-");
    var start = Number(coords[0]);
    var end = Number(coords[1]);

    if(start >= 100000){
        start = start - 100000;
    }
    end = end + 100000;

    if(this.curation_page === true) {
      start = Number(coords[0]);
      end = Number(coords[1]);
    }
    
    var locus = chr+":"+start+"-"+end;
    // Create the igv.js component.
    const igvOptions = {
      genome: this.assembly, 
      showAllChromosomes: false,
      locus: locus,
      tracks: this.tracks
    };
    return igv.createBrowser(this.container.current, igvOptions).then(function(browser) {
      browser.on('trackclick', (track, popoverData) => {
        let markup = '<table class="styled-table">';
        if(!popoverData || popoverData.length === 0)
          return false;
        for(let i=0; i< popoverData.length; i+=1) {
          let element = popoverData[i];
          if(element.name) {
            let html_name = element.value;
            if(element.name.toLowerCase() === "name") {
              //name structure: vistaId.alleleId - backbone - stage
              let splitted = element.value.split(" - ");
              let id_splitted = splitted[0].split(".");
              let vista = id_splitted[0];
              let allele = id_splitted[1];
              let backbone = splitted[1];
              let stage = splitted[2];
              let url = `/vista/element?vistaId=${vista}&alleleId=${allele}&backbone=${backbone}&stage=${stage}`;
              html_name = "<a href='"+url+"' rel='noreferrer' target='_blank' style='color:blue'>"+element.value+"</a>";
            } 
            markup += "<tr><td><b>" + element.name + "</b>: </td><td>" + html_name + "</td></tr>";
          } else {
            // not a name/value pair
            markup += "<tr><td>" + element.toString() + "</td></tr>";
          }
        }
        markup += "</table>";
        return markup;
      });
    });
  }

  render() {
    // Return the div that will contain igv.js
    return (
      <div ref={this.container}  style={igvStyle}></div>
    );
  }
}


export default IgvTrackVewer;